import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./styled.css";
// componentes
import ReadQrcode from "./readQrcode";
// service
import {
  getConfigQrCode,
  getListQrCode,
  getListQrCodeRead,
} from "../../services/qrCode";

import { existsInEvent } from "../../services/login-event";

function darkenHexColor(hex, percent) {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex || "");
  if (!match) return hex;

  let value = match[1];
  if (value.length === 3) {
    value = value
      .split("")
      .map((c) => c + c)
      .join("");
  }

  const num = parseInt(value, 16);
  const channel = (shift) =>
    Math.max(0, Math.round(((num >> shift) & 0xff) * (1 - percent)));

  const r = channel(16);
  const g = channel(8);
  const b = channel(0);

  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export default function Qrcode2() {
  // parametros
  const [searchParams] = useSearchParams();
  // usuario
  const [user, setUser] = useState(null);
  // carregamento
  const [loading, setLoading] = useState(true);
  // config
  const [colorBg, setColorBg] = useState("#ffffff");
  const [colorBtn, setColorBtn] = useState("#0f20db");
  const [imgLogo, setImgLogo] = useState(null);
  const [listCodesRead, setListCodesRead] = useState([]);
  const [listAllCodes, setListAllCodes] = useState([]);
  const [showQrcodeList, setShowQrcodeList] = useState(false);
  const [limitByPeriod, setLimitByPeriod] = useState(false);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [buttonName, setButtonName] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  // erros
  const [errors, setErrors] = useState("");

  async function getConfig() {
    try {
      const res = await getConfigQrCode(user.idEvent);

      if (res?.data?.total > 0) {
        const data = res.data.data[0];

        setColorBg(data.backgroundColor);
        setColorBtn(data.buttonColor);
        setImgLogo(data.image);
        setShowQrcodeList(data.showQrcodeList);
        setLimitByPeriod(data.limitByPeriod);
        if (data.limitByPeriod) {
          setDateStart(new Date(data.startDate));
          setDateEnd(new Date(data.endDate));
        }
        if (data.buttonName) {
          setButtonName(data.buttonName);
          setModalContent(data.content);
        }

        getListRead();
        getList();
      } else if (res?.data?.total === 0) {
        setErrors("Evento sem configuração");
      } else {
        setErrors(
          "Erro na requisição dos dados da página, tente novamente em breve"
        );
      }
    } catch (error) {
      console.error("erro", error);
      setErrors(
        "Erro na requisição dos dados da página, tente novamente em breve"
      );
    } finally {
      setLoading(false);
    }
  }

  async function getListRead() {
    try {
      const res = await getListQrCodeRead(user.idEvent, user.idPart);

      if (res?.data?.total && res.data.total > 0) {
        setListCodesRead(res.data.data);
      }
    } catch (error) {
      console.error("list erro", error);
    }
  }

  async function getList() {
    try {
      const res = await getListQrCode(user.idEvent);

      if (res?.data?.total && res.data.total > 0) {
        setListAllCodes(res.data.data);
      }
    } catch (error) {
      console.error("list erro", error);
    }
  }

  useEffect(() => {
    const idPart = searchParams.get("idPart");
    const idEvent = searchParams.get("idEvent");

    if (idPart && idEvent) {
      checkLoginExistsInEvent(idEvent, idPart);
    } else {
      setErrors("Erro ao ler participante e/ou evento.");
      setLoading(false);
    }
  }, [searchParams]);

  useEffect(() => {
    if (user) getConfig();
  }, [user]);

  async function checkLoginExistsInEvent(idEvent, idPart) {
    try {
      const res = await existsInEvent(idEvent, idPart);

      if (res?.message === "FOUND") {
        setUser({
          idPart,
          idEvent,
        });
      } else {
        setErrors("Participante não cadastrado no evento, contate o suporte.");
        setLoading(false);
      }
    } catch (error) {
      console.error("erro", error);
      setErrors(
        "Erro na requisição dos dados da página, tente novamente em breve"
      );
      setLoading(false);
    }
  }

  return (
    <div
      className="div-general-qrcode"
      style={{
        background: `linear-gradient(to bottom, ${colorBg}, ${darkenHexColor(
          colorBg,
          0.3,
        )})`,
        maxWidth: "100%"
      }}
    >
      {loading ? (
        <a className="a-loading" />
      ) : errors ? (
        <div className="div-error">
          <h4>{errors}</h4>
        </div>
      ) : (
        <ReadQrcode
          colorBtn={colorBtn}
          imgLogo={imgLogo}
          listCodesRead={listCodesRead}
          listAllCodes={listAllCodes}
          user={user}
          getListRead={getListRead}
          showQrcodeList={showQrcodeList}
          limitByPeriod={limitByPeriod}
          dateStart={dateStart}
          dateEnd={dateEnd}
          buttonName={buttonName}
          modalContent={modalContent}
        />
      )}
    </div>
  );
}
